module.exports = __webpack_public_path__ + "static/connection-23b6a34f95ec3d4369bda23eb64b1f3d.png";